import React from "react";
import { Placeholder } from "react-bootstrap";

function SubTable({ data, header }) {
  const orders = ["1 Order", "2 Order", "3 Order", "3+ Orders"];

  return data ? (
    <div style={{ marginTop: "-1.1rem", marginBottom: "-.38rem" }}>
      <div className="text-center">
        <p className="m-0 my-3 py-2 fs-2 border border-2 text-primary rounded">
          {header || "Today"}
        </p>
      </div>
      <table className="table">
        <thead className="pb-0">
          <div
            style={{ background: "#E9F1FD" }}
            className="border rounded border-2 border-primary  d-flex"
          >
            {data.header.map((column, index) => (
              <p className="flex-1 fw-bold m-0" key={index}>
                {column}
              </p>
            ))}
          </div>
        </thead>
        <tbody className="w-100">
          {Object.entries(data).map(([key, row], index) => {
            return key !== "header" ? (
              <div
                id="table-row-value"
                className="d-flex border rounded align-items-center mt-2  w-100"
                key={index}
              >
                {row.map((value, index) => {
                  return index !== 0 ? (
                    <p className="flex-1 m-0 text-primary fw-bold " key={index}>
                      {value}
                    </p>
                  ) : (
                    <p
                      style={{ background: "#E9F1FD" }}
                      className="flex-1 m-0"
                      key={index}
                    >
                      {value}
                    </p>
                  );
                })}
              </div>
            ) : null;
          })}
        </tbody>
      </table>
    </div>
  ) : (
    <div>
      <div style={{ marginTop: "-1.1rem", marginBottom: "-.38rem" }}>
        <div className="text-center">
          <p className="m-0 my-3 py-2 fs-2 border border-2 text-primary rounded">
            Day
          </p>
        </div>
        <table className="table">
          <thead className="pb-0">
            <div
              style={{ background: "#E9F1FD" }}
              className="border rounded border-2 border-primary  d-flex"
            >
              {["Time", "Lost", "Calls", "IVR", "SLOT", "Chat"].map(
                (column, index) => (
                  <p className="flex-1 fw-bold m-0" key={index}>
                    {column}
                  </p>
                )
              )}
            </div>
          </thead>
          <tbody className="w-100 d-flex flex-column pt-1">
            {orders.map((order, index) => (
              <div
                key={index}
                className="border flex-1 p-0 d-flex my-1 rounded"
              >
                <div
                  className="flex-1 border-end "
                  style={{ background: "#E9F1FD" }}
                >
                  {order}
                </div>
                {Array.from({ length: 6 }).map((_, i) => (
                  <Placeholder
                    key={i}
                    as="p"
                    animation="wave"
                    className="flex-1 mb-0"
                  >
                    <Placeholder xs={12} bg="primary"/>
                  </Placeholder>
                ))}
              </div>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default SubTable;
